import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  standalone: false,
  selector: 'null-cake-item',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './null-cake-item.component.html',
  styleUrls: ['./null-cake-item.component.scss']
})
export class NullCakeItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
